/**
 * Describe a payload instead of carrying it.
 *
 * "Did the API return 0 rows or 50?" stays answerable; the rows themselves
 * never leave the process. This is what makes the strict-PII bar provable
 * rather than best-effort — you cannot leak a value you never serialised.
 */
export function summariseShape(value: unknown, depth = 0): string {
  if (value === null) return 'null';
  if (value === undefined) return 'undefined';

  const type = typeof value;
  if (type === 'string') return `string(${(value as string).length})`;
  if (type === 'number' || type === 'boolean' || type === 'bigint') return type;

  if (Array.isArray(value)) {
    const head = value.length > 0 && depth < 2 ? summariseShape(value[0], depth + 1) : '?';
    return `array(${value.length})<${head}>`;
  }

  if (type === 'object') {
    const keys = Object.keys(value as object);
    if (depth >= 2) return `object(${keys.length} keys)`;
    const shown = keys.slice(0, 24).sort().join(',');
    return `object{${shown}${keys.length > 24 ? ',…' : ''}}`;
  }

  return type;
}
